import { Box } from "@mui/material";
import { FC } from "react";
import { NdpInsuredPerson } from "../../../../api";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { BodyTextM, HeadingM } from "../Typography";
import * as Styled from "./InsuranceCoverageAccordion.styled";

type InsuranceCoverageBeneficiariesModalBodyProps = {
    person: NdpInsuredPerson;
};

export const InsuranceCoverageBeneficiariesModalBody: FC<InsuranceCoverageBeneficiariesModalBodyProps> = ({
    person,
}) => {
    const { t } = useTypedTranslation();

    return (
        <Box>
            <Styled.InsuranceCoverageBeneficiariesModalBodyStack>
                <HeadingM sx={{ mb: 0 }}>{t("life.contractDetail.coverags.beneficiaries")}</HeadingM>
            </Styled.InsuranceCoverageBeneficiariesModalBodyStack>
            <BodyTextM>{person.fufiBeneficiaryString ?? t("life.contractDetail.coverags.noBeneficiaries")}</BodyTextM>
        </Box>
    );
};
